import React from "react";
import styles from "./styles.css";

const PostBcVasHighCostCard = () => {
    return (
        <div styleName={"styles.outer"}>
            <div styleName={"styles.gradientWrapper"}>
                <p styleName={"styles.heading"}>50%<span>Australians push out necessary repairs due to high costs</span></p>
                <p styleName={"styles.subHeading"}>Source : NRMA, transport survey</p>
            </div>
        </div>
    );
};

export default PostBcVasHighCostCard;
